import { ErrorScreen } from "./ErrorScreen";
import React from "react";

export const NotFound = () => <ErrorScreen heading="404 :(" />;
